import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#1976D2", // Azul educacional principal
        secondary: "#424242", // Cinza escuro para contraste
        accent: "#00BCD4", // Ciano para destaque
        error: "#F44336", // Vermelho para erros
        warning: "#FF9800", // Laranja para avisos
        info: "#2196F3", // Azul claro para informações
        success: "#4CAF50", // Verde para sucessos
        background: "#FAFAFA", // Fundo muito claro
        surface: "#FFFFFF", // Superfícies brancas
        "on-primary": "#FFFFFF", // Texto em elementos primários
        "on-secondary": "#FFFFFF", // Texto em elementos secundários
        "on-background": "#212121", // Texto em fundo
        "on-surface": "#212121", // Texto em superfícies
        "grey-lighten-5": "#FAFAFA",
        "grey-lighten-4": "#F5F5F5",
        "grey-lighten-3": "#EEEEEE",
        "grey-lighten-2": "#E0E0E0",
        "grey-lighten-1": "#BDBDBD",
        grey: "#9E9E9E",
        "grey-darken-1": "#757575",
        "grey-darken-2": "#616161",
        "grey-darken-3": "#424242",
        "grey-darken-4": "#212121",
      },
      dark: {
        primary: "#2196F3", // Azul mais claro para dark mode
        secondary: "#90A4AE", // Cinza azulado
        accent: "#00E5FF", // Ciano vibrante
        error: "#FF5252", // Vermelho claro
        warning: "#FFC107", // Amarelo para avisos
        info: "#03DAC6", // Ciano para informações
        success: "#66BB6A", // Verde claro
        background: "#121212", // Fundo escuro
        surface: "#1E1E1E", // Superfícies escuras
      },
    },
    options: {
      customProperties: true,
    },
  },
});
